"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autoscout24HealthScore = void 0;
const core_1 = require("@angular/core");
let Autoscout24HealthScore = class Autoscout24HealthScore {
    constructor() {
        this.tagClass = '';
    }
    ngOnChanges() {
        if (this.score === undefined) {
            this.tagClass = '';
            return;
        }
        if (this.score >= 80)
            this.tagClass = 'green';
        if (this.score >= 50 && this.score < 80)
            this.tagClass = 'orange';
        if (this.score < 50)
            this.tagClass = 'red';
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Number)
], Autoscout24HealthScore.prototype, "score", void 0);
Autoscout24HealthScore = __decorate([
    (0, core_1.Component)({
        selector: 'autoscout24-health-score',
        template: /* html */ `
    <tag [color]="tagClass">
      <span>{{ score || "-" }}%</span>
    </tag>
  `,
    })
], Autoscout24HealthScore);
exports.Autoscout24HealthScore = Autoscout24HealthScore;
